import { isEmpty } from 'lodash';

export const getResponseData = (data: any) => {
  return !isEmpty(data) ? data : [];
};
